import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export interface SpeedDialOption {
  label: string;
  value: string;
}

export type SpeedDialDirection = 'top' | 'bottom' | 'left' | 'right';

@Component({
  selector: 'vfs-speed-dial',
  templateUrl: './speed-dial.component.html',
  styleUrls: ['./speed-dial.component.scss']
})
export class SpeedDialComponent implements OnInit {
  protected static readonly LAYOUTS = {
    top: 'column-reverse',
    bottom: 'column',
    left: 'row-reverse',
    right: 'row'
  };

  @Input() label: string;
  @Input() icon: string;
  @Input() direction: SpeedDialDirection = 'right';
  @Input() active = false;
  @Input() disabled = false;
  @Input() toggleOnClick = false;
  @Input() options: SpeedDialOption[];
  @Output() optionSelect = new EventEmitter<string>();

  layout: string;

  ngOnInit() {
    this.layout = SpeedDialComponent.LAYOUTS[this.direction];
  }

  doToggle() {
    this.active = !this.active;
  }

  doAction(option: SpeedDialOption) {
    if (this.toggleOnClick) {
      // this.doToggle();
    }
    this.optionSelect.emit(option.value);
  }
}
